<div class="ibox detailed-view-ibox" *ngIf="stripeAccountsService.showDetailedView && stripeAccountsService.selectedItems.length > 0">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">Make Payout for</div>
        <span class="close-detailed-view" (click)="stripeAccountsService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <div class="content">
                <div class="row">
                    <div class="dv-label col-md-7">
                        <label>Available Balance:</label>
                    </div>
                    <div class="dv-value col-md-5">
                        {{stripeAccountsService.availableBalance | currency}}
                    </div>
                </div>

                <div class="row">
                    <div class="dv-label col-md-7">
                        <label>Number of selected Transactions:</label>
                    </div>
                    <div class="dv-value col-md-5">{{stripeAccountsService.selectedItems.length}}</div>
                </div>

                <div class="row">
                    <div class="dv-label col-md-7">
                        <label>Pay Out Sum:</label>
                    </div>
                    <div class="dv-value col-md-5"
                         [ngClass]="{'red-text': stripeAccountsService.availableBalance < getPayOutSum()}">
                        {{getPayOutSum() | currency}}
                    </div>
                </div>

                <div class="row" (dblclick)="turnEditMode(true)">
                    <div class="dv-label col-md-12">
                        <label>Description:</label>
                    </div>
                    <div class="dv-value col-md-12" *ngIf="!descriptionEditMode">
                        {{!description ? getDefaultDescription() : description}}
                        <i (click)="turnEditMode(true)"
                           class="fa fa-pencil pull-right"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Edit">
                        </i>
                    </div>
                    <div class="dv-value-edit col-md-12" *ngIf="descriptionEditMode">
                        <textarea class="form-control" name="description" [(ngModel)]="description" required></textarea>
                        <button type="button" (click)="turnEditMode(false)">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="cancelEdit()">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="btn-group">
                <button class="btn btn-primary submit-btn"
                        type="button"
                        [disabled]="(stripeAccountsService.availableBalance < getPayOutSum()) || (getPayOutSum() <= 0) || payOutDisabled"
                        (click)="payOut()">
                    Pay Out
                </button>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/stripe-accounts/stripe-accounts-detailed-view/stripe-accounts-detailed-view.component.html